import React from "react";

function Loader () {
  let minHeight = document.getElementById('main-container') ? window.innerHeight - document.getElementById('main-container').offsetTop : 700;
  let booksContainerStyles = {
    minHeight
  };
  return (
    <div style={booksContainerStyles} className="loader-background">
      <div id="loader-container">
        <p id="loadingText">Loading</p>
      </div>
    </div>
  );
}

export default Loader;



/** WEBPACK FOOTER **
 ** ./src/components/Books/Loader.js
 **/